import gql from 'graphql-tag';

export const RootCompositeEntityNode = gql`
mutation createRootCompositeEntityNode($input:RootCompositeEntityNodeInput)
 {
    createRootCompositeEntityNode(input:$input) {
	 graphTemplate
    displayNodeName
    order
    configObjectId
    name
    configObjectType
    createdBy
    isDeleted
    itemDescription
    addedHidden
    insert_ts
    projectId
    updatedBy
    update_ts
    deletionDate
        privileges{
            privilegeType
            roleId
            isDeleted
        }
        parentRelations
            {
              parentItemId
              relationType
              isDeleted
            }
          
        childRelations
            {
              childItemId
              relationType
              isDeleted
            }
          
    }
}
`;